export default (function () {
  return {
    useConfig: process.env.VUE_APP_ENV,
    showKpiArea: true,
    showUpsIntegration: true,
    puescSenderData: {
      street: 'Słoneczna',
      house_number: '4',
      post_code: '06-100',
      city: 'Pułtusk'
    },
    additionalConfig: {
      'production': {
        apiServerUrl: 'https://headwear.thecamels.pl/',
        allowServicePackagesAdd: false,
        showWarehouseBoxesUI: true,
        showHafciarniaIntegration: true,
        hafciarniaUrl: 'https://hafciarnia.thecamels.pl/',
        sewingRoomUrl: 'https://szwalnia.thecamels.pl/',
        offerProcessingTimeID: 2
      },
      'staging': {
        apiServerUrl: 'https://headwear.the-dev.org/',
        allowServicePackagesAdd: true,
        showWarehouseBoxesUI: true,
        showHafciarniaIntegration: true,
        hafciarniaUrl: 'https://hafciarnia.the-dev.org/',
        sewingRoomUrl: 'https://szwalnia.the-dev.org/',
        offerProcessingTimeID: 2
      },
      'development': {
        apiServerUrl: 'https://headwear2.the-dev.org/',
        allowServicePackagesAdd: true,
        showWarehouseBoxesUI: true,
        showHafciarniaIntegration: true,
        hafciarniaUrl: 'https://hafciarnia2.the-dev.org/',
        sewingRoomUrl: 'https://szwalnia2.the-dev.org/',
        offerProcessingTimeID: 2
      }
    }
  }
})();
